<header class="anc-page-header" [class.anc-page-header--borderless]="!titleBordered()">
    <h5 class="anc-page-header__title" translate>{{ title() }}</h5>
    @if (showClose()) {
        <button
            type="button"
            class="anc-page-header__close"
            [attr.aria-label]="'Close' | translate"
            (click)="closeClick.emit()"
        >
            <i class="icon icon--24 icon-x" aria-hidden="true"></i>
        </button>
    }
</header>
